// Abas.js — a fila de abas das telas sem barra lateral.
//
// Técnico e preparador tinham uma cada, e não eram a mesma: uma em forma de
// pílula azul, outra sublinhada. Duas pessoas que trabalham no mesmo núcleo
// abriam o portal e viam sistemas diferentes.
//
// Ficou a pílula, porque é a que aguenta sete abas quebrando em duas
// linhas: a sublinhada só funciona enquanto tudo cabe numa linha só, e não
// cabia no celular.

import { BRANCO, CINZA_ESC, BORDA, RAIO, ACAO, PERIGO } from "../tema";
import Icone from "./Icone";

export default function Abas({ abas, ativa, onEscolher, style = {} }) {
  return (
    <div
      role="tablist"
      style={{ display: "flex", gap: 8, marginBottom: 20, flexWrap: "wrap", ...style }}
    >
      {abas.map(a => {
        const ligada = ativa === a.id;
        return (
          <button
            key={a.id} role="tab" aria-selected={ligada} type="button"
            onClick={() => onEscolher(a.id)}
            style={{
              display: "inline-flex", alignItems: "center", gap: 8,
              background: ligada ? ACAO : BRANCO,
              color: ligada ? BRANCO : CINZA_ESC,
              border: `1px solid ${ligada ? ACAO : BORDA}`,
              borderRadius: RAIO.md, padding: "9px 15px",
              fontSize: 13.5, fontWeight: ligada ? 700 : 600,
              fontFamily: "inherit", cursor: "pointer", whiteSpace: "nowrap",
              boxShadow: ligada ? "0 1px 2px rgba(29, 99, 232, 0.3)" : "none",
              transition: "background 0.12s, color 0.12s",
            }}
          >
            {a.icone && <Icone nome={a.icone} tamanho={16} />}
            {a.label}
            {/* O número do que espera decisão. Vermelho mesmo na aba
                aberta: o que muda ao abrir é a aba, não a pendência. */}
            {a.selo > 0 && (
              <span style={{
                background: ligada ? BRANCO : PERIGO,
                color: ligada ? ACAO : BRANCO,
                fontSize: 11, fontWeight: 800, minWidth: 20, height: 20,
                borderRadius: 20, display: "inline-flex", alignItems: "center",
                justifyContent: "center", padding: "0 6px",
              }}>{a.selo}</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
